import * as React from 'react';
import { getDisplayName } from './getDisplayName';

// tslint:disable-next-line: no-any
export function wrapDisplayName(Component: React.ComponentType<any>, hocName: string): string {
  return `${hocName}(${getDisplayName(Component)})`;
}
